freespinsMultiplierAnim = {};
freespinsMultiplierAnim.multiplierTextObj = undefined;
freespinsMultiplierAnim.winAmountTextObj = undefined;
freespinsMultiplierAnim.sparkles = undefined;
freespinsMultiplierAnim.afterAmount = 0;
freespinsMultiplierAnim.finishedCallBack = undefined;

freespinsMultiplierAnim.initialise = function () {
  freespinsMultiplierAnim.parentContainer = resourceManager.get(
    "slotContainer:freeSpinsMultiplierWinAnim"
  );

  freespinsMultiplierAnim.winAmountTextObj = resourceManager.get(
    "slotContainer:freeSpinsMultiplierWinAnim:WinAmount"
  );
  freespinsMultiplierAnim.multiplierTextObj = resourceManager.get(
    "slotContainer:freeSpinsMultiplierWinAnim:Multiplier"
  );
  freespinsMultiplierAnim.sparkles = resourceManager.get(
    "slotContainer:freeSpinsMultiplierWinAnim:MultiplierSparkles"
  );
  freespinsMultiplierAnim.sparkles.gotoAndStop(0);
  freespinsMultiplierAnim.sparkles.visible = false;

  const xPos = 0 + 126;
  const yPos = 0;
  freespinsMultiplierAnim.winAmountTextObj.position = { x: xPos, y: yPos };
  freespinsMultiplierAnim.multiplierTextObj.position = {
    x: xPos,
    y: 0 - 160,
  };
};

freespinsMultiplierAnim.startAnim = function (
  beforeAmount,
  afterAmount,
  multiplier,
  cb
) {
  gameController.inMultiplierAnim = true;
  gameController.overSizedInProcess = true;
  gameController.stopSymbolFrameDisplay();
  freespinsMultiplierAnim.finishedCallBack = cb;
  freespinsMultiplierAnim.winAmountTextObj.setText(
    "" + gdk.formatCurrency(beforeAmount)
  );

  freespinsMultiplierAnim.multiplierTextObj.setText("X" + multiplier);
  freespinsMultiplierAnim.afterAmount = gdk.formatCurrency(afterAmount);
  Reflex.registerEventHandler(
    "orientationChange",
    freespinsMultiplierAnim.orientationChange.bind(this)
  );

  const xPos = 0 + 126;
  const yPos = 0;
  freespinsMultiplierAnim.winAmountTextObj.visible = true;
  freespinsMultiplierAnim.winAmountTextObj.position = { x: xPos, y: yPos };
  freespinsMultiplierAnim.winAmountTextObj.alpha = 0;
  gsap.to(freespinsMultiplierAnim.winAmountTextObj, {
    duration: 0.2,
    alpha: 1,
  });
  freespinsMultiplierAnim.startAnimTween = gsap.to(
    freespinsMultiplierAnim.winAmountTextObj.scale,
    {
      duration: 0.6,
      ease: "power1.in",
      x: 1,
      y: 1,
      onStart: () => {
        freespinsMultiplierAnim.winAmountTextObj.scale = { x: 0, y: 0 };
      },
      onComplete: () => {
        freespinsMultiplierAnim.showMultiplier();
      },
    }
  );
};

freespinsMultiplierAnim.showMultiplier = function () {
  soundManager.play("fsMultiplierCrash");
  freespinsMultiplierAnim.startAnimTween = undefined;

  const xPos = 0 + 126;
  const yPos = 0;
  freespinsMultiplierAnim.multiplierTextObj.visible = true;
  freespinsMultiplierAnim.multiplierTextObj.position = { x: xPos, y: yPos };
  gsap.to(freespinsMultiplierAnim.multiplierTextObj, {
    duration: 0.2,
    alpha: 1,
  });
  freespinsMultiplierAnim.showMultiplierAnimTween = gsap.to(
    freespinsMultiplierAnim.winAmountTextObj.position,
    {
      duration: 0.6,
      ease: "power1.in",
      y: 0 - 160,
      onStart: () => {},
      onComplete: () => {},
    }
  );

  gsap.to(freespinsMultiplierAnim.multiplierTextObj.scale, {
    duration: 0.6,
    ease: "power1.in",
    x: 1,
    y: 1,
    onStart: () => {
      freespinsMultiplierAnim.multiplierTextObj.scale = { x: 0, y: 0 };
    },
    onComplete: () => {
      // Small delay
      freespinsMultiplierAnim.showMultiplierAnimTween = undefined;
      timerManager.addTimeout(
        750,
        freespinsMultiplierAnim.moveValueIntoMultiplier.bind(this)
      );
    },
  });
};

freespinsMultiplierAnim.moveValueIntoMultiplier = function () {
  const xPos = 0;
  const yPos = 0;

  freespinsMultiplierAnim.moveValueIntoMultiplierAnimTween = gsap.to(
    freespinsMultiplierAnim.winAmountTextObj.position,
    {
      duration: 1,
      ease: "back.in",
      y: yPos,
      onStart: () => {},
      onComplete: () => {
        freespinsMultiplierAnim.winAmountTextObj.setText(
          "" + freespinsMultiplierAnim.afterAmount
        );
      },
    }
  );

  gsap.to(freespinsMultiplierAnim.multiplierTextObj, {
    duration: 0.6,
    alpha: 0,
  });

  freespinsMultiplierAnim.sparkles.visible = true;
  freespinsMultiplierAnim.sparkles.gotoAndStop(0);
  freespinsMultiplierAnim.sparkles.play();
  freespinsMultiplierAnim.sparkles.onComplete =
    freespinsMultiplierAnim.endAnim.bind(this);
};

freespinsMultiplierAnim.endAnim = function () {
  freespinsMultiplierAnim.sparkles.visible = false;

  if (gameController.multiplier > 1) {
    gameController.winningsContainer.visible = true;
    gameData.winningsMeter.add(gameController.winTask.data.totalLineWinnings);
    gameData.winningsMeterMobile.add(
      gameController.winTask.data.totalLineWinnings
    );
  }

  timerManager.addTimeout(1000, function () {
    Reflex.deregisterEventHandler(
      "orientationChange",
      freespinsMultiplierAnim.orientationChange.bind(this)
    );
    freespinsMultiplierAnim.moveValueIntoMultiplierAnimTween = undefined;
    freespinsMultiplierAnim.winAmountTextObj.visible = false;
    freespinsMultiplierAnim.multiplierTextObj.visible = false;
    gameController.inMultiplierAnim = false;
    freespinsMultiplierAnim.finishedCallBack();
    freespinsMultiplierAnim.finishedCallBack = undefined;
    for (let reel = 0; reel < gameData.numReels; reel++) {
      gameData.reels[
        reel
      ].onSpin(); /*a bit hacky but i'm transferring data over to the spin coins*/
      gameData.reels[reel].redraw();
    }
  });
};

freespinsMultiplierAnim.orientationChange = function () {
  if (freespinsMultiplierAnim.startAnimTween !== undefined) {
    if (freespinsMultiplierAnim.startAnimTween.progress() >= 0.75) {
      freespinsMultiplierAnim.startAnimTween.progress(1);
    } else {
      freespinsMultiplierAnim.startAnimTween.progress(0);
    }
    freespinsMultiplierAnim.winAmountTextObj.visible = true;
    freespinsMultiplierAnim.multiplierTextObj.visible = true;
  } else if (freespinsMultiplierAnim.showMultiplierAnimTween) {
    if (freespinsMultiplierAnim.showMultiplierAnimTween.progress() >= 0.75) {
      freespinsMultiplierAnim.showMultiplierAnimTween.progress(1);
    } else {
      freespinsMultiplierAnim.showMultiplierAnimTween.progress(0);
    }
    freespinsMultiplierAnim.winAmountTextObj.visible = true;
    freespinsMultiplierAnim.multiplierTextObj.visible = true;
  } else if (freespinsMultiplierAnim.moveValueIntoMultiplierAnimTween) {
    if (
      freespinsMultiplierAnim.moveValueIntoMultiplierAnimTween.progress() >=
      0.75
    ) {
      freespinsMultiplierAnim.moveValueIntoMultiplierAnimTween.progress(1);
    } else {
      freespinsMultiplierAnim.moveValueIntoMultiplierAnimTween.progress(0);
    }
    freespinsMultiplierAnim.winAmountTextObj.visible = true;
    freespinsMultiplierAnim.multiplierTextObj.visible = false;
  }
};
